import { instagramQueries } from '@round/api';
import { useQuery } from '@tanstack/react-query';

const audioQueryOptions = instagramQueries.audio.options.detail;

export function useAudioIndicators(id: number) {
    const { data, status, error } = useQuery(audioQueryOptions(id));

    const indicators = [
        {
            label: 'Creations',
            value: data?.reels_count,
        },
        {
            label: 'Creations (last 7 days)',
            value: data?.reels_count_weekly_change,
            relativeValue: data?.reels_count_weekly_change_relative,
        },
        {
            label: 'Daily Creations',
            value: data?.reels_count_daily_change,
            relativeValue: data?.reels_count_daily_change_relative,
        },
    ];

    return {
        indicators,
        status,
        error,
    };
}
